/* ÉTRE – Bildauswahl und Duo-Angebot */

(() => {
  'use strict';

  if (window.etrePurchaseLoaded) return;
  window.etrePurchaseLoaded = true;

  function init(root) {
    if (root.dataset.ready === 'true') return;

    const variants = JSON.parse(
      root.querySelector('[data-etre-variants]').textContent
    );

    if (!variants.length) return;

    const byId = new Map(
      variants.map(v => [String(v.id), v])
    );

    const form = root.querySelector('form');
    const select = root.querySelector('[data-etre-variant]');
    const first = byId.get(select.value) || variants[0];

    const alternative =
      variants.find(v => v.available && v.id !== first.id) || first;

    const state = {
      first: first.id,
      second: alternative.id,
      duo: false,
      busy: false
    };

    const product = root.closest('.product');
    const price = product.querySelector('.product-info__price');
    const submit = root.querySelector('[data-etre-submit]');
    const submitLabel = root.querySelector('[data-etre-submit-label]');
    const error = root.querySelector('[data-etre-error]');
    const stock = root.querySelector('[data-etre-stock]');
    const offers = root.querySelector('[data-etre-offers]');
    const slots = [...root.querySelectorAll('[data-etre-slot]')];

    const money = new Intl.NumberFormat(
      document.documentElement.lang || 'de-DE',
      {
        style: 'currency',
        currency: root.dataset.currency || 'EUR'
      }
    );

    const format = cents => money.format(cents / 100);

    const duoAllowed =
      root.dataset.duoEnabled === 'true' &&
      root.dataset.currency === 'EUR' &&
      variants.every(v => v.price === 3499);

    function items() {
      const result = [
        { id: state.first, quantity: 1 }
      ];

      if (state.duo) {
        if (state.first === state.second) {
          result[0].quantity = 2;
        } else {
          result.push({
            id: state.second,
            quantity: 1
          });
        }
      }

      return result;
    }

    function availability() {
      const chosen = items();

      if (chosen.some(item => !byId.get(item.id).available)) {
        return 'Ein ausgewähltes Design ist ausverkauft.';
      }

      if (
        chosen.some(item => {
          const v = byId.get(item.id);

          return (
            v.inventoryLimit !== null &&
            item.quantity > v.inventoryLimit
          );
        })
      ) {
        return 'Dieses Design ist nicht zweimal verfügbar. Bitte kombiniere zwei unterschiedliche Designs.';
      }

      return '';
    }

    function setImage(v) {
      const img = product.querySelector('[data-gallery-main] img');

      if (img && v.image) {
        img.src = v.image;
        img.removeAttribute('srcset');

        const title = product
          .querySelector('.product-info__title')
          .textContent.trim();

        img.alt = `${title} – ${v.title}`;
      }

      product.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        thumb.classList.toggle(
          'is-active',
          thumb.dataset.mediaId === v.mediaId
        );
      });
    }

    function refresh() {
      const v = byId.get(state.first);
      select.value = state.first;

      if (price) {
        price.replaceChildren();

        const total = state.duo ? 6499 : v.price;
        const compare = state.duo ? 6998 : v.comparePrice;

        if (compare > total) {
          const old = document.createElement('s');
          old.textContent = format(compare);
          price.append(old, document.createTextNode(' '));
        }

        price.append(document.createTextNode(format(total)));

        price.classList.toggle(
          'product-info__price--sale',
          compare > total
        );
      }

      const singlePrice = root.querySelector('[data-etre-single-price]');

      if (singlePrice) {
        singlePrice.textContent = format(v.price);
      }

      slots.forEach(slot => {
        const second = slot.dataset.etreSlot === '2';
        const selected = second ? state.second : state.first;

        slot.hidden = second && !state.duo;

        slot.querySelector('[data-etre-slot-label]').textContent =
          second ? 'Gürtel 2' : (state.duo ? 'Gürtel 1' : 'Design');

        slot.querySelector('[data-etre-selected-title]').textContent =
          byId.get(selected).title;

        slot.querySelectorAll('[data-etre-choice]').forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.etreChoice === selected)
          );

          button.disabled =
            state.busy ||
            !byId.get(button.dataset.etreChoice).available;
        });
      });

      const note = root.querySelector('[data-etre-duo-note]');

      if (note) {
        note.hidden = !state.duo;
      }

      root.querySelectorAll('[name="etre_offer"]').forEach(radio => {
        radio.disabled = state.busy;
        radio.checked = (radio.value === 'duo') === state.duo;
      });

      const problem = availability();

      stock.classList.toggle('is-unavailable', Boolean(problem));

      stock.querySelector('[data-etre-stock-text]').textContent =
        problem || 'Verfügbar – in 2–4 Werktagen bei dir!';

      submit.disabled = state.busy || Boolean(problem);

      submitLabel.textContent = state.busy
        ? 'WIRD HINZUGEFÜGT …'
        : (
          problem
            ? 'AUSWAHL NICHT VERFÜGBAR'
            : (
              state.duo
                ? '2 GÜRTEL IN DEN WARENKORB'
                : 'IN DEN WARENKORB'
            )
        );

      form.setAttribute('aria-busy', String(state.busy));
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-etre-choice]');

      if (
        !button ||
        !root.contains(button) ||
        state.busy ||
        button.disabled
      ) {
        return;
      }

      const v = byId.get(button.dataset.etreChoice);
      const slot = button.closest('[data-etre-slot]');

      if (slot.dataset.etreSlot === '1') {
        state.first = v.id;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } else {
        state.second = v.id;
      }

      error.hidden = true;
      setImage(v);
      refresh();
    });

    root.addEventListener('change', event => {
      if (event.target.name !== 'etre_offer' || state.busy) {
        return;
      }

      state.duo = duoAllowed && event.target.value === 'duo';
      error.hidden = true;

      if (!state.duo) {
        setImage(byId.get(state.first));
      }

      refresh();
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();

      if (state.busy || availability()) return;

      state.busy = true;
      error.hidden = true;
      refresh();

      try {
        const response = await fetch(root.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items()
          })
        });

        const data = await response.json();

        if (!response.ok || data.status >= 400) {
          const message = typeof data.description === 'string'
            ? data.description
            : 'Die Auswahl konnte nicht vollständig hinzugefügt werden.';

          throw new Error(message);
        }

        window.location.assign(root.dataset.cartUrl);
      } catch (err) {
        root.querySelector('[data-etre-error-text]').textContent =
          `${err.message || 'Das Hinzufügen konnte nicht bestätigt werden.'} Bitte prüfe deinen Warenkorb, bevor du es erneut versuchst.`;

        error.hidden = false;
        state.busy = false;
        refresh();
      }
    });

    root.dataset.ready = 'true';

    if (offers) {
      offers.hidden = !duoAllowed;
    }

    root.querySelector('.etre-purchase__fallback').hidden = true;

    refresh();
    setImage(first);

    window.addEventListener('pageshow', () => {
      if (state.busy) {
        state.busy = false;
        refresh();
      }
    });
  }

  function scan(scope) {
    scope.querySelectorAll('[data-etre-purchase]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document));
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', event => {
    scan(event.target);
  });
})();